import React, { useContext, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

import "./style.css";

const ProfilePage = (props) => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [timeDiff, setTimeDiff] = useState("");
  const userRef = props.match == undefined ? firestore.collection("usersData").doc(user.uid) : firestore.collection("usersData").doc(props.match.params.userId) 
  React.useEffect(() => {
    userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          data.userPersonal = data.userPersonal==undefined ? {} : data.userPersonal;
          data.userExperience = data.userExperience==undefined ? {} : data.userExperience;
          data.userContact = data.userContact==undefined ? {} : data.userContact;
          data.userDescription = data.userDescription==undefined ? {} : data.userDescription;
          setUserData(data);
          let months;
          let d1 = new Date();
          let d2 = data.userPersonal.userStartDay;
          let d2Date = new Date(d2);
          months = (d2Date.getFullYear() - d1.getFullYear()) * 12;
          months -= d1.getMonth();
          months += d2Date.getMonth();
          months = months <= 24 ? 1 : months / 12;
          months = Number.isNaN(months) ? '' : months
          setTimeDiff(months);
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  if (!userData) return <div>Loading Data</div>;
  const sections = [
    { title: "פרופיל", url: "/Profile"},
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} navBarDisconnect = {true}/>
      </Container>
      <hr />
      <div className="profile-page-wrapper">
        <div className="profile-page-header">
          <img
            className="profile-page-image"
            src={userData.userImageDownloadUrl || 'https://source.unsplash.com/dLij9K4ObYY/900x900/'}
          />
          <div className="profile-page-personal">
            <span className="profile-page-data" style={{ fontWeight: "700" }}>
              {userData.userFullName}
            </span>
            <span className="profile-page-data">
              ותק (בשנים): {timeDiff}
            </span>
            <span className="profile-page-data">
              מספר רשיון: {userData.userPersonal.licenseNumber}
            </span>
          </div>
        </div>
        <hr />

        <div className="profile-page-personal">
          <span className="profile-page-sideHeader">דרכי התקשרות</span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              מספר הטלפון במשרד:{" "}
            </label>{" "}
            {userData.userPersonal.phoneNumberOffice}
          </span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              מספר סלולר:{" "}
            </label>{" "}
            {userData.userPersonal.phoneNumberCell}
          </span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              כתובת המשרד:{" "}
            </label>{" "}
            {userData.userPersonal.officeAddress}
          </span>
        </div>
        <hr />
        <div className="profile-page-personal">
          <span className="profile-page-sideHeader">התמחות</span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator"> התמחויות: </label>{" "}
            {userData.userExperience.mainExperience},{" "}
            {userData.userExperience.secondaryExperience == undefined ? [] : userData.userExperience.secondaryExperience.map((ex) => `${ex}, `)}
          </span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              אזורי התמחות:{" "}
            </label>{" "}
            {userData.userExperience.mainLocation},
            {userData.userExperience.secondaryLocation == undefined? [] : userData.userExperience.secondaryLocation.map((ex) => `${ex}, `)}
          </span>
        </div>
        <hr />
        <div className="profile-page-personal">
          <span className="profile-page-sideHeader">ערוצי אינטרנט</span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              אתר המשרד:{" "}
            </label>{" "}
            <a target="_blank" href={userData.userContact.officeWebsite}>{userData.userContact.officeWebsite}</a>
          </span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              דף לינקדאין:{" "}
            </label>{" "}
            <a target="_blank" href={userData.userContact.userLinkedIn}>{userData.userContact.userLinkedIn}</a>
          </span>
          <span className="profile-page-data">
            <label className="profile-page-tabIdentificator">
              {" "}
              דף פייסבוק:{" "}
            </label>{" "}
            <a target="_blank" href={userData.userContact.officeFacebook}>{userData.userContact.officeFacebook}</a>
          </span>
        </div>
        <hr />
        <div className="profile-page-personal">
          <span className="profile-page-sideHeader">קצת עלי</span>
          <span className="profile-page-data">
            {userData.userDescription.userDescriptionExp}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
